// extracted by mini-css-extract-plugin
export default {"input-with-search":"InputWithSearch_input-with-search__aeNJo","search-icon":"InputWithSearch_search-icon__9E1zn"};